<svelte:options customElement="dst-promotion" />

<script lang="ts">
	import { jubileeTimespans } from '@/config.ts';
	import { Logger } from '@/lib/log.ts';
	import { mdiPartyPopper } from '@mdi/js';

	const log = Logger('header.DstPromotion');

	export let isapp;
	const isOverview = window.DERSTANDARD?.pageConfig?.pageType === 'overview';

	const webUrls = {
		abo: 'https://abo.derstandard.at/?ref=abowidget&utm_source=derstandard&utm_medium=button&utm_campaign=Abo',
		immo: 'https://immobilien.derstandard.at/suche/oesterreich/mieten-wohnung/?ref=dt&utm_source=derstandard&utm_medium=widget&utm_campaign=navibutton',
		jobs: 'https://jobs.derstandard.at/p/l/oesterreich/?ref=dt&utm_source=derstandard&utm_medium=widget&utm_campaign=navibutton',
		jubilee:
			'https://abo.derstandard.at/kampagne/jubel-ew/?ref=JubelButton&utm_source=derstandard&utm_medium=button&utm_campaign=aboakquise&utm_content=jubilaeum&utm_term=Jubelbutton',
		supporter:
			'https://checkout.derstandard.at/produkt/monatliche-unterstuetzung/?ref=SupporterButton&utm_source=derstandard&utm_medium=button&utm_campaign=Supporter',
	};

	const appUrls = {
		abo: 'https://abo.derstandard.at/?ref=abowidget&utm_source=derstandard-App&utm_medium=button&utm_campaign=Abo',
		immo: 'https://immobilien.derstandard.at/suche/oesterreich/mieten-wohnung/?ref=dt&utm_source=derstandard&utm_medium=widget&utm_campaign=navibutton',
		jobs: 'https://jobs.derstandard.at/p/l/oesterreich/?ref=dt&utm_source=derstandard&utm_medium=widget&utm_campaign=navibutton',
		jubilee:
			'https://abo.derstandard.at/kampagne/jubel-ew/?ref=JubelButton&utm_source=derstandard&utm_medium=button&utm_campaign=aboakquise&utm_content=jubilaeum&utm_term=Jubelbutton',
		supporter:
			'https://checkout.derstandard.at/produkt/monatliche-unterstuetzung/?ref=SupporterButton&utm_source=derstandard-App&utm_medium=button&utm_campaign=Supporter',
	};

	const urls = isapp ? appUrls : webUrls;

	// Provide testing functionality via localStorage
	try {
		const debugTimespan = localStorage.getItem('jubilee');

		if (debugTimespan) {
			jubileeTimespans.push(JSON.parse(debugTimespan));
		}
	} catch (e) {
		log.error('getting jubilee timespans from localStorage failed ', e);
	}

	const currentDate = Date.now();

	const isJubilee = jubileeTimespans.map((timespan) => {
		const startDate = new Date(timespan.start).getTime();
		const endDate = new Date(timespan.end).getTime();

		return currentDate >= startDate && currentDate <= endDate;
	});
</script>

<nav class:overview={isOverview}>
	{#if isJubilee.includes(true)}
		<a href={urls.jubilee} class="theme-jubilee">
			Jubelangebot
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16px" height="16px">
				<path fill="currentColor" d={mdiPartyPopper} />
			</svg>
		</a>
	{:else}
		<a href={urls.supporter} class="theme-supporter">Unterstützung</a>
	{/if}

	<a href={urls.abo} class="theme-abo">Abo</a>
	<a href={urls.immo} class="theme-immobilien">Immobilien <span>50k+</span></a>
	<a href={urls.jobs} class="theme-jobs">Jobs <span>3000+</span></a>
</nav>

<style lang="scss" global>
	@use './DstPromotion.scss';
</style>
